import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Title, BackLink, PageHeader, Button } from '../../components'
import channels from '../../channels/languages/german'


const LanguagesGrammarPage = ({ intl }) => (
  <div className="page">
    <BackLink />
    <PageHeader title={intl.formatMessage(messages.title)} />

    <div className="row width-full grammar-languages-list">
      <div className="grammar-languages-list-item">
        <Link to={`/grammar/german`}>
          <h1>{intl.formatMessage(messages.german)}</h1>
          <img src="/assets/images/flags/de.png" alt="German" />
        </Link>
      </div>
    </div>
  </div>
)

LanguagesGrammarPage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(LanguagesGrammarPage)

const messages = defineMessages({
  title: {
    id: 'videos.page.title',
    defaultMessage: 'Gramatika',
  },
  german: {
    id: 'videos.page.german',
    defaultMessage: 'Nemčina',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/grammar/LanguagesGrammarPage.js